export default __webpack_public_path__ + "static/data-vis-text-charts-dont-abc831fc5cc228101d61ea8d264674e6527ed5dc096c95a4ce58f3399e71b843.png";